const getMainBlockHotels = (hotelResults, specialOfferHotelResults) => {
	// -> filter out the special offer hotels (if there are any) from our main block results so that a hotel only appears once on a page
	let mainBlockHotelResults = [];
	if (specialOfferHotelResults.length > 0) {
		// Create an array of special offer ids that have already appeared on the page in 'specialOfferHotelResults'
		const specialOfferIds = specialOfferHotelResults.map(offer => offer._id)
		// Filter out the above hotels with special offers so they do not appear on the page more than once
		mainBlockHotelResults = hotelResults.map(rank => rank.filter(hotel => !specialOfferIds.includes(hotel._id) ? hotel : false))
	} else {
		mainBlockHotelResults = hotelResults;
	}

	// remove duplicates & this is our main block of hotels
	mainBlockHotelResults = [...new Set(mainBlockHotelResults)].flat(1);

	return mainBlockHotelResults;
};

export { getMainBlockHotels };
